import React from 'react';
import { connect } from 'react-redux';
import { Switch, Route, withRouter, Redirect, Link } from 'react-router-dom';
import _ from 'lodash';
import PropTypes from 'prop-types';
import CedulaTaggingContainer from './requirements/container/CedulaTaggingContainer';

function CdlSettingsContainer({ match, pathName }) {

  return (
    <React.Fragment>
      <div className="card-content-listing">
        <div className="container-fluid">
          <div className="row">
            <ul className="nav nav-tabs btn-settings-tab-container">
              <li className="nav-item">
                <Link
                  to="/cedula/settings"
                  className={`nav-link btn-settings-tab border-right py-3 px-5 ${pathName.indexOf(
                    '/cedula/settings/requirements-tagging'
                  ) > -1
                    ? 'selected'
                    : ''
                    }`}
                >
                  Requirements Tagging
                </Link>
              </li>
            </ul>
          </div>
        </div>
        <Switch>
          <Route
            exact
            path={`${match.path}`}
            render={() => <Redirect to={`${match.path}/requirements-tagging`} />}
          />
          <Route
            path={`${match.path}/requirements-tagging`}
            component={CedulaTaggingContainer}
          />
        </Switch>
      </div>
    </React.Fragment>
  );
}

CdlSettingsContainer.propTypes = {
  match: PropTypes.instanceOf(Object).isRequired,
  pathName: PropTypes.string.isRequired,
};

const mapStateToProps = ({ api }, { match, location }) => ({
  mainModule: _.get(match, 'params.mainModule'),
  pathName: _.get(location, 'pathname'),
  profile: _.get(api, 'AUTH/user_profile.item') || {},
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps)]);

export default enhance(CdlSettingsContainer);
